// extracted by mini-css-extract-plugin
export default {"default":"up-down_default__J6cav","up":"up-down_up__b9c71","down":"up-down_down__mEQOH"};